"use client";

import React from "react";
import { Instagram, MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-wrap justify-center gap-6">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-16 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4">
      {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="font-mono text-xs font-medium uppercase tracking-widest text-muted-foreground transition-colors duration-300 hover:text-foreground">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="265121" id="footer" className="bg-background text-foreground border-t border-border/20 py-16 px-6 md:py-24">
      <div ref={ref} className={`mx-auto flex max-w-4xl flex-col items-center justify-center gap-12 transition-all duration-1000 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        {}
        <MenuProvider menu_id="45">
          <FooterMenuConsumer />
        </MenuProvider>

        {}
        <div className="h-px w-12 bg-border/20" />

        {}
        <div className="flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:w-full md:text-left">
          <div className="flex flex-col gap-1">
            <p className="font-default text-xs font-bold tracking-widest text-foreground uppercase">
              RHYTHM & SOUL PRODUCTIONS
            </p>
            <p className="font-mono text-[10px] tracking-tight text-muted-foreground uppercase">
              ESTABLISHED MMXXIV — SONIC BRUTALISM
            </p>
          </div>

          <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-foreground hover:bg-transparent transition-colors duration-300">
              <Link to="#" newTab aria-label="Instagram">
                <Instagram className="size-4" strokeWidth={1} />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-foreground hover:bg-transparent transition-colors duration-300">
              <Link to="#" newTab aria-label="WhatsApp">
                <MessageCircle className="size-4" strokeWidth={1} />
              </Link>
            </Button>
            <Button variant="ghost" className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground hover:text-foreground hover:bg-transparent" onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })}>
              Back to Top
            </Button>
          </div>
        </div>
      </div>
    </section>;
}